import { Company } from "../features/companies/models/company"

export const getSectors = (company: Company) => {
  const sectors = company?.sectors ?? []

  if (sectors?.length === 0) return "No sectors"

  return sectors?.map(sector => sector.name).join(" | ")
}
